<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Vendors" title="Vendor Profile" />
         
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            
                            <div class="row mb-3">
                                <div class="col-12">
                                    <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>

                                </div>
                            </div>

                            <div class="row">

                                <div class=" col-lg-6 col-md-6">
                                    <div class="card overflow-hidden">
                                        <div class="bg-soft bg-primary">
                                            <div class="row m-0">
                                            <div class="col-7">

                                            </div>
                                            <div class="col-5 align-self-end">
                                                <img src="@/assets/images/details-img.png" alt="" class="img-fluid" width="150" height="150" />
                                            </div>
                                            </div>
                                        </div>
                                        <div class="card-body pt-2">
                                            <div class="row">
                                                <div class="col-sm-4"> 
                                                    <div class="avatar-md profile-user-wid mb-1">
                                                        <img src="@/assets/images/users/no-user.jpg" alt="" class="img-thumbnail rounded-circle" />
                                                    </div>
                                                </div>

                                                <div class="col-sm-8 align-self-center">
                                                    <h5 class="font-size-15">
                                                        {{vendor.name}}
                                                    </h5>
                                                    <p class="font-size-14 mt-3 mb-1">
                                                        <i class="fa fa-phone me-1 text-primary"></i>
                                                        {{vendor.mobile}}
                                                    </p>
                                                    <p class="font-size-14 mb-1">
                                                        <i class="fa fa-envelope me-1 text-primary"></i>
                                                        {{vendor.email}}
                                                    </p>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <!-- end card -->
                                    <div class="d-grid gap-2">
                                        <!-- <b-button v-b-modal.password-modal block variant="primary">Change Password</b-button> -->
                                    </div>
                                

                                </div>
                            

                                <div class="col-lg-6 col-md-6">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Vendor Details
                                        </h4>

                                        <div class="table table-responsive">
                                            <table class="details-table table-nowrap mb-0">
                                                <tbody>

                                                    <tr width="50%">
                                                        <th scope="row">Type</th>
                                                        <th>:</th>
                                                        <td>{{ vendor.vendor_type == 1 ? 'Manufacturer' : vendor.vendor_type == 2 ? 'Enclosure' : vendor.vendor_type == 3 ? 'Store' : 'N/A' }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Total Boards Manufactured</th>
                                                        <th>:</th>
                                                        <td>{{total_boards_manufactured}}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Joined Date</th>
                                                        <th>:</th>
                                                        <td>{{$filters.formatDate(vendor.created_at)}}</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div> 
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>	
</template>

<script>

   export default {
		name: "Technician Profile",
		

		data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,

				token: "",
				errors: {},
				activate: false,
         		deactivate: false,

                vendor: {},
                total_boards_manufactured:"",

         		active_page_url: null,
			};
		},
        created() {

			this.vendorDetail();

		},

        methods: {

            getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

            vendorDetail(page_url = null) {
				this.getToken();
				let url = '/staffs/vendorDetail?vendor_id=' + this.$route.params.id;
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.vendor = responseData.vendor;
                        this.total_boards_manufactured = responseData.total_boards_manufactured;
                        
					})
					.catch((err) => console.log(err));
			},
            
            
        }

   }


</script>